module.exports = new __parcel__URL__("apollo_1.744c75ae.jpg").toString();